import { InputRightElement as ChakraInputRightElement } from "@chakra-ui/react";

export const InputRightElement = ChakraInputRightElement;
